import { ApprovalRequestsTab } from '../common'
import { Request, RequestHistory } from '../offcycletesting'
import { ContactInformation, ExamsSchedule, SSDAccommodations } from '../common/detail'
import { selectCurrentFilter } from '../../../selectors/filters'
import {
  APPROVAL_REQUEST_CONFIG,
  AR_ID,
  AR_AICODE,
  AR_STATUS,
  AR_EXAMDATE,
  ARTYPE_OFFCYCLETESTING,
} from '../../../constants/ApprovalRequestConstants'

const mapStateToProps = state => {
  return {
    groupByAICode: selectCurrentFilter(state).groupByAICode || false,
  }
}

export const OffCycleTestingTab = connect(mapStateToProps)(({ groupByAICode }) => {
  const requestDetailPanels = [
    {
      title: 'SSD Accommodations',
      PanelBody: SSDAccommodations,
      panelId: 'SSDAccommodationsPanel',
      openByDefault: true,
    },
    {
      title: 'Exams Schedule',
      PanelBody: ExamsSchedule,
      panelId: 'examsSchedulePanel',
      openByDefault: true,
    },
    {
      title: 'Contact Information',
      PanelBody: ContactInformation,
      panelId: 'contactInformationPanel',
    },
    { title: 'Request History', PanelBody: RequestHistory, panelId: 'requestHistoryPanel' },
  ]

  const headerColumns = [
    {
      headerText: { title: 'ID' },
      headerAttributes: { id: 'approvalRequestIdCol' },
      key: [`${APPROVAL_REQUEST_CONFIG[ARTYPE_OFFCYCLETESTING].idField}`, 'examDate'],
      sortDir: ['asc', 'asc'],
    },
    {
      headerText: { title: 'AI Code' },
      headerAttributes: { id: 'aiCodeCol' },
      key: ['aiCode', 'examDate'],
      sortDir: ['asc', 'asc'],
    },
    {
      headerText: { title: 'Exam Date' },
      headerAttributes: { id: 'examDateCol' },
      key: ['examDateType', 'aiCode'],
      sortDir: ['asc', 'asc'],
      defaultSort: true,
    },
    {
      headerText: { title: 'Status' },
      headerAttributes: { id: 'statusCol' },
      key: ['statusSortOrder', 'examDate'],
      sortDir: ['asc', 'asc'],
    },
  ]

  const approvalRequestColumns = [
    { header: AR_ID },
    { header: AR_AICODE },
    { header: AR_EXAMDATE },
    { header: AR_STATUS },
  ]

  return (
    <ApprovalRequestsTab
      title="Off-Cycle Testing"
      arType={ARTYPE_OFFCYCLETESTING}
      tableSummary={`Off-Cycle Testing approval requests are listed in ascending order ${
        groupByAICode ? 'grouped by AI code' : 'by course name and AI code'
      }.`}
      headerColumns={headerColumns}
      approvalRequestColumns={approvalRequestColumns}
      RequestComponent={Request}
      requestDetailPanels={requestDetailPanels}
    />
  )
})
